import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import Navbar from './Navbar';
import Footer from './Footer';
import ScrollToTop from './ScrollToTop';
import { settingsService } from '../services/api';

const PUBLIC_BASE = (process.env.REACT_APP_API_URL || 'http://localhost:8888/api').replace('/api', '') + '/public';

const Layout = () => {
	const location = useLocation();
	const isHome = location.pathname === '/';
	const [bgUrl, setBgUrl] = useState(null);

	useEffect(() => {
		let cancelled = false;
		settingsService.getSettings()
			.then(res => {
				if (cancelled) return;
				const path = res?.data?.userBackground?.path;
				if (path) setBgUrl(`${ PUBLIC_BASE }${ path }`);
			})
			.catch(() => { });
		return () => { cancelled = true; };
	}, []);

	return (
		<Box
			sx={ {
				display: 'flex', flexDirection: 'column', minHeight: '100vh', overflowX: 'hidden',
				bgcolor: '#0B0C10',
				...(bgUrl ? {
					backgroundImage: `url(${ bgUrl })`,
					backgroundSize: 'cover',
					backgroundPosition: 'center',
					backgroundAttachment: 'fixed',
					backgroundRepeat: 'no-repeat',
				} : {}),
			} }
		>
			<Navbar />
			<Box
				component="main"
				sx={ {
					flexGrow: 1,
					px: { xs: 1.5, md: 3 },
					pb: { xs: 1.5, md: 3 },
					// Trang chủ: hero nằm dưới header trong suốt → không pad top
					// Các trang khác: chừa chỗ cho header fixed (64px) + 24px
					pt: isHome ? 0 : { xs: '76px', md: '88px' },
				} }
			>
				<Outlet />
			</Box>
			<Box sx={ { mx: { xs: -1.5, md: -3 } } }>
				<Footer />
			</Box>
			{ !location.pathname.startsWith('/chat') && <ScrollToTop /> }
		</Box>
	);
};

export default Layout;
